<template>
  <div class="app">

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>
    
    <!-- TABLEAU -->
    <v-layout row wrap>
      <v-flex md3>
        <el-card class="box-card" style="background:#fff; margin: 10px">
          <v-card-title>
            <v-flex md12 class="sousTraitInfo mb-2 pb-2">
              INFORMATION DE LA DEMANDE
            </v-flex>
            <v-flex md12>
              Référence : <v-chip color="primary" label text-color="white"> DEMD-{{id_dmd}}</v-chip>
            </v-flex>
            <v-flex md12>
              Motif : {{detailDemande.motif}}
            </v-flex>
            <v-flex md12>
              Demandeur : <v-chip outline color="primary" label text-color="primary">{{detailDemande.dmdeur}}</v-chip>
            </v-flex>
            <v-flex md12>
              Etat de la demande : <v-chip :color="detailDemande.type" label text-color="white"> {{detailDemande.etat_dmd}}</v-chip>
            </v-flex>
            <v-flex md12>
              Date de la demande : {{detailDemande.date_dmd}}
            </v-flex>
            <v-flex md12>
              Lieu concerné par la demande : 
              <p>{{detailDemande.zone}}</p> 
                <p>{{detailDemande.zone1}}</p> 
                <p>{{detailDemande.zone2}}</p> 
                <p>{{detailDemande.zone3}}</p> 
                <p>{{detailDemande.zone4}}</p>
              <v-chip color="orange" icon label text-color="white"> 
                {{detailDemande.lieu}}<v-icon>location_on</v-icon> 
              </v-chip>
            </v-flex>
            <v-flex md12>
              Date d'enrégistrement : {{detailDemande.created}}
            </v-flex>
            <v-flex md12>
              Date de modification : {{detailDemande.modified}}
            </v-flex>
          </v-card-title>
        </el-card>
      </v-flex>

      <v-flex md9>
        <el-card class="box-card" style="background:#fff; margin: 10px">
          <v-chip text-color="white" label color="primary">
            LISTE DES CONSTATS EFFECTUES
          </v-chip>
          <div class="text-xs-right" v-if="listConstat.length === 0">
            <v-tooltip top>
              <v-btn color="primary" slot="activator" @click.stop="newConstat" dark>Ajouter
                <v-icon dark right>add</v-icon>
              </v-btn>
              <span>Ajouter un nouveau constat</span>
            </v-tooltip>
          </div>

          <!--tableau de constat-->
          <v-data-table v-bind:headers="headers_constat" v-bind:items="listConstat" v-bind:search="search_constat" class="elevation-1" no-data-text="Aucune données" rows-per-page-text="Ligne(s) par page">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator"> {{ props.header.text }} </span>
                <span> {{ props.header.text }} </span>
              </v-tooltip>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                <v-chip text-color="white" label color="primary">
                  {{ props.item.ref }} 
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-chip text-color="white" label color="orange">
                  {{ props.item.superviseur }} 
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-chip v-if="props.item.etat === 0" text-color="white" label color="primary">
                  EN ATTENTE DE TRAITEMENT
                </v-chip>
                <v-chip v-if="props.item.etat === 1" text-color="white" label color="green">
                  VALIDER
                </v-chip>
                <v-chip v-if="props.item.etat === 2" text-color="white" label color="red">
                  REFUSE
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-chip outline text-color="primary" label color="primary">
                  {{ props.item.categorie }} 
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <v-btn slot="activator" @click.stop="showConstat(props.item)" fab dark small color="green">
                    <v-icon dark>folder_open</v-icon>
                  </v-btn>
                  Détails
                </v-tooltip>
                <v-tooltip top v-if="props.item.etat === 0">
                  <v-btn slot="activator" @click.stop="editConstat(props.item)" fab dark small color="primary">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  Modifier
                </v-tooltip>
                <v-tooltip top v-if="props.item.etat === 0">
                  <v-btn slot="activator" @click.stop="newValidation(props.item)" fab dark small color="green">
                    <v-icon dark>done_all</v-icon>
                  </v-btn>
                  Valider
                </v-tooltip>
                <v-tooltip top v-if="props.item.etat === 0">
                  <v-btn slot="activator" @click.stop="dialogSupr = true; idConst = props.item.id;" fab dark small color="red">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  Supprimer
                </v-tooltip>
              </td>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              Ligne {{ pageStart }} à {{ pageStop }}
            </template>
          </v-data-table>
        </el-card>
      </v-flex>
    </v-layout>

    <!-- MODAL SHOW CONSTAT -->
    <v-dialog v-model="dialogShow" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>Détails du constat {{detailConstat.ref}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{detailConstat.ref}} </p>
                          <p><b>Superviseur : </b> {{detailConstat.superviseur}} </p>
                          <p><b>Prestataire : </b> {{detailConstat.prestataire}} </p>
                          <p><b>Catégorie : </b> {{detailConstat.categorie}} </p>
                          <p><b>Etat : </b>
                            <v-chip v-if="detailConstat.etat === 0" text-color="white" label color="primary">
                              EN ATTENTE DE TRAITEMENT
                            </v-chip>
                            <v-chip v-if="detailConstat.etat === 1" text-color="white" label color="green">
                              VALIDER
                            </v-chip>
                            <v-chip v-if="detailConstat.etat === 2" text-color="white" label color="red">
                              REFUSE
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md6>
                          <p v-if="detailConstat.etat === 1"><b>Motif de validation : </b> {{detailConstat.descriptionValide}} </p>
                          <p v-if="detailConstat.etat === 2"><b>Motif de réfus : </b> {{detailConstat.descriptionValide}} </p>
                          <p><b>Description: </b> {{detailConstat.description}} </p>
                          <p><b>Date d'enrégistrement : </b> {{detailConstat.created}} </p>
                          <p><b>Date de modification : </b> {{detailConstat.modified}} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="detailConstat.etat === 0" slot="activator" icons color="primary" @click.stop="editConstat(detailConstat)" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT CONSTAT -->
    <v-dialog v-model="dialogAjoutCst" max-width="70%" persistent >
      <v-card>     
        <v-toolbar dark color="primary">
          <v-toolbar-title class="white--text"> Ajouter un nouveau constat
            <h6 class="caption">Yamoussoukro / zone ouest</h6>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutCst = false" dark><v-icon>close</v-icon> </v-btn>         
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formConstat" lazy-validation id="formConstat">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  Ajout d'un nouveau constat
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md6>
                  <v-text-field label="Prestataire" name="prestataire" v-model="listParam.nomPrestataire" disabled></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-select label="Superviseur" name="superviseur" v-bind:items="users" v-model="constat.nomPrenSuperv" item-value="id" item-text="nom" :rules="[v => !!v || 'Veuillez sélectionner le superviseur']" required autocomplete></v-select>
                </v-flex>
              </v-layout>

              <v-layout row justify>
                <v-flex md6>
                  <v-select label="Catégorie" v-bind:items="listCategorie" v-model="constat.selectCat" item-value="idCat" item-text="libelCat" :rules="[v => !!v || 'Veuillez selectionner une categorie']" required autocomplete></v-select>
                </v-flex>
                <v-flex md6>
                  <v-text-field label="Remarque" name="descRmq" v-model="constat.descRmq" multi-line rows = 3></v-text-field>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  JOINDRE DES FICHIERS
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md12>
                  <div style="margin-bottom:5px;">Documents joints (images)</div>
                  <el-upload :action="constat.fichier.url" list-type="picture-card" :on-preview="handlePictureCardPreview" :auto-upload="false" multiple name="photo[]" :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>

                  <el-dialog :visible.sync="dialogVisible" size="tiny">
                    <img width="100%" :src="dialogImageUrl" alt>
                  </el-dialog>
                </v-flex>
              </v-layout>

              <v-btn @click="dialogAjoutCst = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submit" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>            
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDER CONSTAT -->
    <v-dialog v-model="dialogAjoutValid" max-width="50%" persistent >
      <v-card>     
        <v-toolbar dark color="green">
          <v-toolbar-title class="white--text"> Valider le constat de la demande DEMD-{{id_dmd}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutValid = false" dark><v-icon>close</v-icon> </v-btn>         
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formValidation" lazy-validation id="formValidation">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip text-color="white" label color="green" style="font-size:22px; width:100%">
                  Validation du constat DEMD-{{id_dmd}} - {{detailDemande.motif}}
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md6>
                  <v-select label="Catégorie" v-bind:items="validation" v-model="slectValidation" item-value="value"  :rules="[v => !!v || 'Veuillez sélectionner votre réponse']" required></v-select>
                </v-flex>
                <v-flex md6>
                  <v-text-field label="Remarque" name="description" v-model="descriptionValid" multi-line rows = 3></v-text-field>
                </v-flex>
              </v-layout>
        
              <v-btn @click="dialogAjoutValid = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitValider" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>            
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION CONSTAT -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer cet enrégistrement ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteConst" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  </div>
</template>

<style>
  .sousTrait {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    margin-bottom: 10px;
  }  
  
  .sousTraitInfo {
    border-bottom: 1px solid black;
    font-weight: bold;
  }
</style>

<script>
  export default {
    name: "app",
    data() {
      return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        userCon: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        racourcis: [
          { path: '/', text: 'Accueil', disabled: false },
          { path: '/maintenance', text: 'Maintenance', disabled: false },
          { path: '/demande', text: 'Demande', disabled: false },
          { path: '/', text: 'Détails de la demande', disabled: true }
        ],
        valid: true,
        dialogAjoutCst: false,
        dialogAjoutValid: false,
        dialogEdit: false,
        dialogShow: false,
        dialogSupr: false,
        dialogImageUrl: '',
        dialogVisible: false,
        id_dmd: this.$route.params.demande_id,
        detailDemande: [],
        constat: {
          fichier:{url:''},
          descRmq:'',
          nomPrenSuperv: null,
          selectCat: null,
        },
        msgInfo: 0,
        search_constat: '',
        headers_constat: [
          { text: 'Référence', align: 'center', sortable: false, value: 'ref' },
          { text: 'Superviseur', align: 'center',  sortable: false, value: 'superviseur' },
          { text: 'Etat', align: 'center', sortable: false, value: 'etat' },
          { text: 'Catégorie', align: 'center', sortable: false, value: 'categorie' },
          { text: 'Actions', align: 'center' }
        ],
        listParam: [],
        listCategorie: [],
        listConstat: [],
        detailConstat: [],
        constatCourant: [],
        idConst: '',
        validation: [
          { text: 'VALIDER', value: 1 },
          { text: 'REFUSE', value: 2 }
        ],
        slectValidation: null,
        descriptionValid: '',
        users: []
      }
    },
    mounted() {
      this.loadPage()
      this.loadUser()
      this.loadCategorie()
      this.loadParametre()
      this.loadDemande()
      this.loadConstat()
    },
    methods: {
      loadPage () {
        const loading = this.$loading({
          lock: true,
          text: 'Veuillez patientez ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 1000)
      },
      loadUser(){
        let url = this.domaine + 'userCreate/user-list'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.users = response.body
          }
        })
      },
      loadDemande () {
        if(this.$route.params.demande_id != 0) {
          let url = this.domaine + 'demande/'+ this.id_dmd +'/show'
          this.$http.get(url).then( (response)=>{
            this.detailDemande = response.body.demande
          })
        }
      },
      loadCategorie() {
        let url = this.domaine + 'demande/index/categorie';
        this.$http.get(url).then( (response)=>{
          this.listCategorie = response.body.listCats
        })
      },
      loadParametre () {
        let url = domaine + 'webService/index/parametre'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listParam = response.body.param
          }
        })
      },
      loadConstat () {
        let url = this.domaine + 'demande/'+ this.id_dmd +'/index/constat'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listConstat = response.body.constat
          }
        })
      },
      newConstat () {
        this.dialogAjoutCst = true
        this.dialogEdit = false
        this.constat = {
          fichier:{url:''},
          descRmq:'',
          nomPrenSuperv:null,
          selectCat: null,
        }
      },
      newValidation (ligne) {
        this.constatCourant = ligne
        this.dialogAjoutValid = true
        this.slectValidation = null
        this.descriptionValid = ''    
      },
      editConstat (ligne) {
        this.constatCourant = ligne
        this.dialogAjoutCst = true
        this.dialogEdit = true
        this.constat = {
          fichier:{url:''},
          descRmq: ligne.description,
          nomPrenSuperv: ligne.idSup,
          selectCat: ligne.idCat
        }
      },
      showConstat (ligne) {
        this.dialogShow = true
        this.constatCourant = ligne
        let url = this.domaine + 'demande/' + this.constatCourant.id + '/show/constat'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.detailConstat = response.body.constat
          }
        })
      },
      submit () {
        this.loading = true
        if (this.$refs.formConstat.validate()) {
          var form = document.getElementById('formConstat')
          var data = new FormData(form)
          let url = this.domaine + 'demande/constat'
          data.append('idUser', this.userCon.id)          
          data.append('id_dmd', this.detailDemande.id_dmd)
          data.append('id_cat', this.constat.selectCat)
          data.append('prestataire', this.listParam.prestataire)
          if (this.constatCourant.id) {
            data.append('id', this.constatCourant.id)
          } else {
            data.append('id', '')
          }
          this.$http.post(url, data).then((response) => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                if (this.constatCourant.id) {
                  this.$notify({
                    title: 'MODIFICATION REUSSI',
                    message: 'Constat modifié avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Constat enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                }

                this.dialogAjoutCst = false
                this.loading = false
                this.loadConstat()
                this.loadPage()
                this.$refs.formConstat.reset()
              } else if (verif.code === 1) {
                this.$message.error(verif.message)
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
           }, (response) => {
             this.loading = false;
             this.$message.error("Erreur lors de l'ajout du constat");
           })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le constat n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitValider () {
        this.loading = true
        if (this.$refs.formValidation.validate()) {
          var form = document.getElementById('formValidation')
          var data = new FormData(form)
          let url = this.domaine + 'demande/'+ this.constatCourant.id +'/valider/constat'
          data.append('idUser', this.userCon.id)
          data.append('validation', this.slectValidation)
          
          this.$http.post(url, data).then((response) => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Validation enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                })

                this.dialogAjoutValid = false
                this.loading = false
                this.loadConstat()
                this.loadPage()
                this.$refs.formValidation.reset()
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
           }, (response) => {
             this.loading = false;
             this.$message.error("Erreur lors de l'ajout");
           })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La validation n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      deleteConst () {
        let url = this.domaine + 'demande/' + this.idConst + '/delete/constat'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.$notify({
              title: 'SUPPRESSION',
              message: 'Constat supprimé avec succès.',
              type: 'success',
              position: 'top-center'
            })
            this.dialogSupr = false
            this.loadConstat()
            this.loadPage()
          }
        })
      },
      handleRemove(file, fileList) {
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },
     beforeMount: function () {
      if(!this.roleAcces[this.$router.history.current.name]){
        this.$router.push({ name: 'Home'  })
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/DetailDemande.vue